import { i18n } from "./../../../plugins/vue-i18n";

const validateLegalPersonFullName = {
  validate: validate,
  message: i18n.t("VALIDATION_ERRORS.validateLegalPersonFullName")
};

function validate(input) {
  const matched = /^[А-Яа-я\s\-!?"'><№#@$^:.,*)(\d]*$/.test(input);
  return input !== null && input !== "" && input.length >= 3 && matched;
}

export default validateLegalPersonFullName;
